import { Component, OnInit, ViewChild, afterNextRender } from '@angular/core';
import { FeriasBaseComponent } from '../../ferias-base.component';
import { NavigationEnd, NavigationExtras, Router } from '@angular/router';
import { Menu } from 'primeng/menu';
import { Table } from 'primeng/table';
import { filter, takeWhile } from 'rxjs/operators';
import { FiltroObterVinculoAgentePublico, ParametrosFeriasCargo, ParametrosFeriasOrgao, VinculoAgentePublico, VinculoAgentePublicoComExercicios, VinculosService } from 'src/app/services/vinculos.service';
import { Exercicios, ExercicioSelecionado } from 'src/app/services/exercicios.service';
import { SituacaoExercicioFeriasEnum } from 'src/app/components/shared/enums/situacao-exercicio-ferias.enum';
import { SituacaoParcelaFeriasEnum } from 'src/app/components/shared/enums/situacao-parcela-ferias.enum';
import { TipoFeriasEspecialEnum } from 'src/app/components/shared/enums/tipo-ferias-especial.enum';
import { SegurancaService, SigepeUserData } from '@sigepe/ngx-sigepe-seguranca';
import { AlertMessageService } from '@sigepe/sigepe-template';
import { getDateFromYYYYMMDD, formatDateToYYYYMMDD } from 'src/app/components/shared/date-utils';
import { SituacaoFuncionalEnum } from 'src/app/components/shared/enums/situacao-funcional.enum';
import { EnumTransacao } from 'src/app/components/shared/enums/transacao.enum';
import { EnumPerfil } from 'src/app/components/shared/enums/perfil.enum';
import { Message } from 'src/app/components/shared/message';
import { formatarMensagem } from 'src/app/components/shared/string-utils';

@Component({
    selector: 'app-consultar-exercicios',
    templateUrl: './consultar-exercicios.component.html',
    styleUrls: ['./consultar-exercicios.component.scss']
})
export class ConsultarExerciciosComponent extends FeriasBaseComponent implements OnInit {
    anosExercicios: any[];
    codigoOrgao: number;
    matricula: number;
    situacaoVinculo: boolean;

    exerciciosFerias: any[];
    totalItensResultado = 0;
    tamanhoPagina = 10;

    anos: any[];
    situacoesFerias: any[];
    acaoCarregada = false;

    vinculoSelecionado: VinculoAgentePublico;
    parametrosFeriasOrgao: ParametrosFeriasOrgao;
    parametrosFeriasCargo: ParametrosFeriasCargo;

    @ViewChild('pTableResultado') pTableResultado: Table;

    constructor(
        alertaMsgService: AlertMessageService,
        private vinculosService: VinculosService,
        private router: Router,
        private segurancaService: SegurancaService
    ) {
        super(alertaMsgService);

        //Carrega os dados da navegação (fluxo legado) com fallback para estado persistido (fluxo consulta gerencial)
        const navigationData = this.router.getCurrentNavigation()?.extras?.state?.data || history.state?.data || this.recuperarEstadoConsultaGerencial();
        if (navigationData) {
            this.codigoOrgao = navigationData.codigoOrgao;
            this.matricula = navigationData.matricula;
            this.situacaoVinculo = navigationData.situacaoVinculo;
            // Quando vem da Consulta Gerencial direto para detalhar/homologar,
            // oculta a tela de Consultar Exercícios (mesmo comportamento do fluxo legado ao clicar ação na própria tela).
            if (navigationData.origemTela === 'consulta-gerencial') {
                this.acaoCarregada = true;
            }
        }

        afterNextRender(() => {
            this.alterarTituloTemplate('Gerenciar Férias');
            this.alterarTextoBreadcrumb(1, 'Gerenciar Férias - Buscar Agente Público');
        });
    }

    ngOnInit(): void {
        this.clearMessages();
        this.alterarTituloTemplate('Gerenciar Férias');

        if (!this.acaoCarregada) {
            this.carregarExerciciosFerias();
        }

        this.router.events
            .pipe(
                filter(event => event instanceof NavigationEnd),
                takeWhile(() => this.acaoCarregada)
            )
            .subscribe(event => {
                if ((event as any).url === '/secure/gerenciar-ferias/consultar-exercicios') {
                    this.carregarExerciciosFerias();
                    this.acaoCarregada = false;
                }
            });
    }

    get regimeCeletistaOuAnistiado(): boolean {
        return SituacaoFuncionalEnum.CLT.id === this.vinculoSelecionado.siglaRegime || SituacaoFuncionalEnum.ANISTIADO.id === this.vinculoSelecionado.siglaRegime;
    }

    exercicioEstaNoPrazoParaInterrupcao(anoExercicio: string): boolean {
        //Retorna true se o anoExercicio informado for igual ao ano atual ou ao ano anterior
        return new Date().getFullYear() - parseInt(anoExercicio) <= 1;
    }

    carregarExerciciosFerias() {
        if (!this.codigoOrgao || !this.matricula) {
            return;
        }

        setTimeout(() => {
            this.segurancaService.userData$.subscribe(dadosUsuarioLogado => {
                const filtro: FiltroObterVinculoAgentePublico = {
                    codigoOrgao: this.codigoOrgao,
                    matricula: this.matricula
                };
                const inicioMedicao = this.iniciarMedicaoCarregamentoBuscarAgente('obter-vinculo-com-exercicios', filtro);
                this.vinculosService.obterVinculoAgentePublico(filtro).subscribe({
                    next: (resultadoVinculosAgentePublico: VinculoAgentePublicoComExercicios) => {
                        this.vinculoSelecionado = resultadoVinculosAgentePublico?.dadosServidor;
                        this.parametrosFeriasOrgao = resultadoVinculosAgentePublico?.parametrosFeriasOrgao;
                        this.parametrosFeriasCargo = resultadoVinculosAgentePublico?.parametrosFeriasCargo;

                        //Extrai a sigla do regime
                        if (this.vinculoSelecionado.regime) {
                            this.vinculoSelecionado.siglaRegime = this.vinculoSelecionado.regime.split(' - ')[0];
                        }

                        if (resultadoVinculosAgentePublico && resultadoVinculosAgentePublico.exerciciosFerias && resultadoVinculosAgentePublico.exerciciosFerias.length > 0) {
                            this.exerciciosFerias = resultadoVinculosAgentePublico.exerciciosFerias;

                            this.totalItensResultado = resultadoVinculosAgentePublico.exerciciosFerias.length;

                            this.exerciciosFerias.forEach(exercicio => {
                                //Primeiro tem que "chapar" a estrutura de árvore de parcelas
                                const gerarParcelasExercicio: Function = (parcelaFerias: any[], profundidade = 0, idParcelaPai?: number): any[] => {
                                    //Função recursiva
                                    let parcelasAgregadas: any[] = [];

                                    //Adiciona as parcelas do exercicio de férias atual
                                    parcelaFerias.forEach(parcelaFerias => {
                                        if (parcelaFerias.ordem !== 99) {
                                            //99 são parcelas canceladas e não devem aparecer na grid
                                            parcelaFerias.geracao = profundidade;
                                            parcelaFerias.idParcelaPai = parcelaFerias.idParcelaPai ? parcelaFerias.idParcelaPai : idParcelaPai;
                                            parcelasAgregadas.push(parcelaFerias);

                                            if (parcelaFerias.parcelaFilha) {
                                                parcelasAgregadas = parcelasAgregadas.concat(gerarParcelasExercicio([parcelaFerias.parcelaFilha], profundidade + 1));
                                            }
                                        }
                                    });

                                    return parcelasAgregadas;
                                };
                                if (exercicio.parcelas && exercicio.parcelas.length > 0) {
                                    exercicio.parcelasEmLinha = gerarParcelasExercicio(exercicio.parcelas);
                                    //Tem que ordenar as parcelasEmLinha por ordem e geração
                                    exercicio.parcelasEmLinha.sort((a, b) => {
                                        if (a.ordem === b.ordem) {
                                            return a.geracao - b.geracao;
                                        }
                                        return a.ordem - b.ordem;
                                    });
                                }

                                //Força o campo ano para ser string
                                exercicio.ano = exercicio.ano ? exercicio.ano + '' : '';

                                //Indicador da modalidade especial persistida no exercício
                                exercicio.indicadorFeriasEspeciais = this.obterIndicadorFeriasEspeciais(exercicio);

                                //Cria as opções de acao para cada registro
                                exercicio.acoesPossiveis = [];

                                switch (exercicio.situacao) {
                                    case SituacaoExercicioFeriasEnum.NAO_SOLICITADA.descricao:
                                        if (this.situacaoVinculo) {
                                            this.adicionarAcaoProgramar(dadosUsuarioLogado, exercicio);
                                        }
                                        this.adicionarAcaoFeriasEspeciaisAdministrativas(dadosUsuarioLogado, exercicio);
                                        this.adicionarAcaoFeriasEspeciaisJudiciais(dadosUsuarioLogado, exercicio);
                                        break;

                                    case SituacaoExercicioFeriasEnum.SOLICITADA.descricao:
                                        this.adicionarAcaoDetalhar(dadosUsuarioLogado, exercicio);
                                        if (this.situacaoVinculo) {
                                            this.adicionarAcaoHomologar(dadosUsuarioLogado, exercicio);
                                        }
                                        break;

                                    case SituacaoExercicioFeriasEnum.HOMOLOGADA.descricao:
                                        this.adicionarAcaoDetalhar(dadosUsuarioLogado, exercicio);
                                        if (this.situacaoVinculo) {
                                            this.adicionarAcaoReprogramar(dadosUsuarioLogado, exercicio);
                                            this.adicionarAcaoInterromper(dadosUsuarioLogado, exercicio);
                                            this.adicionarAcaoCancelarInterrupcao(dadosUsuarioLogado, exercicio);
                                        }
                                        this.adicionarAcaoFeriasEspeciaisAdministrativasComParcelas(dadosUsuarioLogado, exercicio);
                                        this.adicionarAcaoFeriasEspeciaisJudiciaisComParcelas(dadosUsuarioLogado, exercicio);
                                        break;

                                    case SituacaoExercicioFeriasEnum.CONCLUIDA.descricao:
                                        this.adicionarAcaoDetalhar(dadosUsuarioLogado, exercicio);
                                        if (this.situacaoVinculo) {
                                            this.adicionarAcaoInterromper(dadosUsuarioLogado, exercicio);
                                            this.adicionarAcaoCancelarInterrupcao(dadosUsuarioLogado, exercicio);
                                        }
                                        this.adicionarAcaoFeriasEspeciaisAdministrativasComParcelas(dadosUsuarioLogado, exercicio);
                                        this.adicionarAcaoFeriasEspeciaisJudiciaisComParcelas(dadosUsuarioLogado, exercicio);
                                        break;

                                    case SituacaoExercicioFeriasEnum.ENCERRADA.descricao:
                                        this.adicionarAcaoDetalhar(dadosUsuarioLogado, exercicio);
                                        break;

                                    default:
                                        break;
                                }
                            });

                            this.anosExercicios = Array.from(new Set(this.exerciciosFerias.map(resultado => resultado.ano)));
                            this.situacoesFerias = Array.from(new Set(this.exerciciosFerias.map(resultado => resultado.situacao)));

                            setTimeout(() => {
                                this.ajustarUsoTecladoGrid(this.pTableResultado);
                                this.getAlertaMsgService().showAwaitingMessage();
                            }, 100);
                        } else {
                            this.getAlertaMsgService().warn(Message.AVISO_FERIAS_CONSULTAR_NO_ORGAO_DE_LOTACAO);
                        }
                    },
                    error: erro => {
                        this.finalizarMedicaoCarregamentoBuscarAgente('obter-vinculo-com-exercicios', inicioMedicao, 'erro', {
                            erro
                        });
                    },
                    complete: () => {
                        this.finalizarMedicaoCarregamentoBuscarAgente('obter-vinculo-com-exercicios', inicioMedicao, 'sucesso', {
                            totalItensResultado: this.totalItensResultado,
                            totalExercicios: this.exerciciosFerias?.length ?? 0
                        });
                    }
                });
            });
        }, 100);
    }

    private recuperarEstadoConsultaGerencial(): any {
        try {
            const estadoSerializado = sessionStorage.getItem('consultaGerencialExercicioSelecionado');
            return estadoSerializado ? JSON.parse(estadoSerializado) : null;
        } catch {
            return null;
        }
    }

    private iniciarMedicaoCarregamentoBuscarAgente(operacao: string, filtro: any): number {
        const inicio = performance.now();
        console.log(`[BuscarAgente][Performance] ${operacao} - INICIO`, {
            inicioMs: inicio,
            filtro
        });
        return inicio;
    }

    private finalizarMedicaoCarregamentoBuscarAgente(operacao: string, inicio: number, status: 'sucesso' | 'erro', dados?: any): void {
        const fim = performance.now();
        const duracaoMs = Math.round((fim - inicio) * 100) / 100;
        console.log(`[BuscarAgente][Performance] ${operacao} - FIM`, {
            status,
            duracaoMs,
            inicioMs: inicio,
            fimMs: fim,
            dados
        });
    }

    contextoCessao(): boolean {
        return this.vinculoSelecionado && this.vinculoSelecionado.contextoCessao;
    }

    orgaoEmExercicioSelecionado(): boolean {
        return this.vinculoSelecionado && this.vinculoSelecionado.codigoOrgaoExercicio === this.vinculoSelecionado.codigoOrgao;
    }

    resgatarParcelaCorrente(parcelaFerias: any, profundidade: number): any {
        if (!parcelaFerias.parcelaFilha) {
            parcelaFerias.geracao = profundidade;
            return parcelaFerias;
        } else {
            return this.resgatarParcelaCorrente(parcelaFerias.parcelaFilha, profundidade + 1);
        }
    }

    detalhar(exercicioFerias): void {
        this.acaoCarregada = true;
        this.router.navigate(['/secure/gerenciar-ferias/consultar-exercicios/detalhar-ferias'], this.obterDadosExercicioSelecionado(exercicioFerias));
    }

    programar(exercicioFerias: Exercicios) {
        this.acaoCarregada = true;
        this.router.navigate(['/secure/gerenciar-ferias/consultar-exercicios/programar-ferias'], this.obterDadosExercicioSelecionado(exercicioFerias));
    }

    reprogramar(exercicioFerias): void {
        this.acaoCarregada = true;
        this.router.navigate(['/secure/gerenciar-ferias/consultar-exercicios/reprogramar-ferias'], this.obterDadosExercicioSelecionado(exercicioFerias));
    }

    homologar(exercicioFerias): void {
        this.acaoCarregada = true;
        this.router.navigate(['/secure/gerenciar-ferias/consultar-exercicios/homologar-ferias'], this.obterDadosExercicioSelecionado(exercicioFerias));
    }

    interromper(exercicioFerias): void {
        this.acaoCarregada = true;
        this.router.navigate(['/secure/gerenciar-ferias/consultar-exercicios/interromper-ferias'], this.obterDadosExercicioSelecionado(exercicioFerias));
    }

    cancelarInterrupcao(exercicioFerias): void {
        this.acaoCarregada = true;
        this.router.navigate(['/secure/gerenciar-ferias/consultar-exercicios/cancelar-interrupcao'], this.obterDadosExercicioSelecionado(exercicioFerias));
    }

    perdaDireito(exercicioFerias): void {
        alert('perdaDireito');
        //this.acaoCarregada = true;
        //this.router.navigate(["/secure/gerenciar-ferias/consultar-exercicios/detalhar-ferias"]);
    }

    indenizar(exercicioFerias): void {
        alert('indenizar');
        //this.acaoCarregada = true;
        //this.router.navigate(["/secure/gerenciar-ferias/consultar-exercicios/detalhar-ferias"]);
    }

    naoIndenizar(exercicioFerias): void {
        alert('naoIndenizar');
        //this.acaoCarregada = true;
        //this.router.navigate(["/secure/gerenciar-ferias/consultar-exercicios/detalhar-ferias"]);
    }

    voltar(): void {
        this.router.navigate(['/secure/gerenciar-ferias/buscar-agente-publico']);
    }

    obterDadosExercicioSelecionado(exercicioFerias: Exercicios): NavigationExtras {
        interface ParcelaComFilhas {
            dataFim: string;
            parcelaFilha?: ParcelaComFilhas;
        }

        const obterParcelasDaHierarquia = (parcelasRaiz: ParcelaComFilhas[]): ParcelaComFilhas[] => {
            const parcelasDaHierarquia: ParcelaComFilhas[] = [];
            let parcelasPendentes = parcelasRaiz;

            while (parcelasPendentes.length > 0) {
                const parcelasFilhas: ParcelaComFilhas[] = [];
                parcelasPendentes.forEach(parcela => {
                    parcelasDaHierarquia.push(parcela);
                    if (parcela.parcelaFilha) {
                        parcelasFilhas.push(parcela.parcelaFilha);
                    }
                });
                parcelasPendentes = parcelasFilhas;
            }

            return parcelasDaHierarquia;
        };

        const obterDataInicioPeriodoProgramacaoDisponivel: Function = exercicioFeriasAProgramar => {
            let dataInicioPeriodoProgramacaoDisponivel = exercicioFeriasAProgramar.dataInicioPeriodoProgramacao;

            const exercicioFeriasAnoPassado = this.exerciciosFerias.find(exercicio => exercicio.ano === exercicioFeriasAProgramar.ano - 1 + '');
            const exercicioFeriasAnoRetrasado = this.exerciciosFerias.find(exercicio => exercicio.ano === exercicioFeriasAProgramar.ano - 2 + '');

            const parcelasAnteriores: ParcelaComFilhas[] = [];

            if (exercicioFeriasAnoPassado && exercicioFeriasAnoPassado.parcelas && exercicioFeriasAnoPassado.parcelas.length > 0) {
                parcelasAnteriores.push(...obterParcelasDaHierarquia(exercicioFeriasAnoPassado.parcelas));
            }

            if (exercicioFeriasAnoRetrasado && exercicioFeriasAnoRetrasado.parcelas && exercicioFeriasAnoRetrasado.parcelas.length > 0) {
                parcelasAnteriores.push(...obterParcelasDaHierarquia(exercicioFeriasAnoRetrasado.parcelas));
            }

            if (parcelasAnteriores && parcelasAnteriores.length > 0) {
                parcelasAnteriores.forEach(parcelaExercicioAnterior => {
                    const dataFimParcelaExercicioAnterior: Date = getDateFromYYYYMMDD(parcelaExercicioAnterior.dataFim);
                    const dataInicioPeriodoProgramacaoDisponivelDate: Date = getDateFromYYYYMMDD(dataInicioPeriodoProgramacaoDisponivel);

                    if (dataFimParcelaExercicioAnterior.getTime() >= dataInicioPeriodoProgramacaoDisponivelDate.getTime()) {
                        const novaDataInicioPeriodoProgramacaoDisponivel = new Date(dataFimParcelaExercicioAnterior);
                        novaDataInicioPeriodoProgramacaoDisponivel.setDate(novaDataInicioPeriodoProgramacaoDisponivel.getDate() + 1);
                        dataInicioPeriodoProgramacaoDisponivel = formatDateToYYYYMMDD(novaDataInicioPeriodoProgramacaoDisponivel);
                    }
                });
            }

            return dataInicioPeriodoProgramacaoDisponivel;
        };

        const dataInicioPeriodoProgramacaoDisponivel = obterDataInicioPeriodoProgramacaoDisponivel(exercicioFerias);

        const exercicioSelecionado: ExercicioSelecionado = {
            //Tem que criar o objeto na mão grande para evitar o erro ao executar o pushState
            idFerias: exercicioFerias.id,
            cpf: this.vinculoSelecionado.cpf,
            nome: this.vinculoSelecionado.nome,
            chefiaImediata: (this.vinculoSelecionado.nomeChefiaImediata ? this.vinculoSelecionado.nomeChefiaImediata : '') + ' - ' + (this.vinculoSelecionado.codigoUorgChefiaImediata ? this.vinculoSelecionado.codigoUorgChefiaImediata : ''),
            vinculoEmExercicio: (this.vinculoSelecionado.matricula ? this.vinculoSelecionado.matricula : '') + ' - ' + (this.vinculoSelecionado.descricaoCargo ? this.vinculoSelecionado.descricaoCargo : ''),
            orgaoEmExercicio: (this.vinculoSelecionado.codigoOrgaoExercicio ? this.vinculoSelecionado.codigoOrgaoExercicio : '') + (this.vinculoSelecionado.siglaOrgaoExercicio ? ' - ' + this.vinculoSelecionado.siglaOrgaoExercicio : '') + ' - ' + (this.vinculoSelecionado.descricaoOrgaoExercicio ? this.vinculoSelecionado.descricaoOrgaoExercicio : ''),
            codigoSituacaoFuncional: this.vinculoSelecionado.codigoSituacaoFuncional,
            regime: this.vinculoSelecionado.regime,
            siglaRegime: this.vinculoSelecionado.regime ? this.vinculoSelecionado.regime.split(' - ')[0] : null,
            anoExercicio: exercicioFerias.ano,
            saldoDias: exercicioFerias.quantidadeDias,
            situacaoExercicio: exercicioFerias.situacao,
            dataInicioPeriodoAquisitivo: exercicioFerias.dataInicioPeriodoAquisitivo,
            dataFimPeriodoAquisitivo: exercicioFerias.dataFimPeriodoAquisitivo,
            dataInicioPeriodoProgramacao: exercicioFerias.dataInicioPeriodoProgramacao,
            dataFimPeriodoProgramacao: exercicioFerias.dataFimPeriodoProgramacao,
            justificativaPerdaDireito: exercicioFerias.justificativaPerdaDireito,
            periodoAquisitivo: exercicioFerias.periodoAquisitivo,
            quantidadeMaximaParcelas: exercicioFerias.quantidadeMaximaParcelas,
            tipoFeriasEspecial: exercicioFerias.tipoFeriasEspecial,
            extraordinario: exercicioFerias.extraordinario,
            sentencaJudicial: exercicioFerias.sentencaJudicial,

            //Só informa o período de programação disponível se for diferente do periodo de programação normal
            dataInicioPeriodoProgramacaoDisponivel: dataInicioPeriodoProgramacaoDisponivel !== exercicioFerias.dataInicioPeriodoProgramacao ? dataInicioPeriodoProgramacaoDisponivel : undefined,
            dataFimPeriodoProgramacaoDisponivel: dataInicioPeriodoProgramacaoDisponivel !== exercicioFerias.dataInicioPeriodoProgramacao ? exercicioFerias.dataFimPeriodoProgramacao : undefined,

            parcelas: exercicioFerias.parcelas,

            //TODO: ver como vai ficar a obtenção do backend da informação sobre Raio-X
            raioX: false,

            parametrosFeriasOrgao: this.parametrosFeriasOrgao,
            parametrosFeriasCargo: this.parametrosFeriasCargo
        };

        return {
            state: {
                data: exercicioSelecionado
            }
        } as NavigationExtras;
    }

    possuiTransacao(transacao: EnumTransacao, dadosUsuarioLogado: SigepeUserData): boolean {
        if (!dadosUsuarioLogado || !dadosUsuarioLogado.transacoes || dadosUsuarioLogado.transacoes.length === 0) {
            return false;
        }
        return dadosUsuarioLogado.transacoes.some(t => t.toLowerCase() == transacao.descricao.toLowerCase());
    }

    possuiPerfil(perfil: EnumPerfil, dadosUsuarioLogado: SigepeUserData): boolean {
        if (!dadosUsuarioLogado || !dadosUsuarioLogado.perfis || dadosUsuarioLogado.perfis.length === 0) {
            return false;
        }
        return dadosUsuarioLogado.perfis.some(p => p.toLowerCase() == perfil.descricao.toLowerCase());
    }

    gestorPodeExecutarAcoes(dadosUsuarioLogado: SigepeUserData): boolean {
        let podeExecutarAcoes = true;

        //Só no vínculo no órgão em exercício todas as ações estarão habilitadas
        if (!this.vinculoSelecionado.orgaoExercicioExterno && this.contextoCessao() && !this.orgaoEmExercicioSelecionado()) {
            //Não permite exercutar ações se:
            //  1. o órgão em exercício NÃO é órgão externo (ou seja, NÃO é caso de cessão para órgão não-SIAPE); E
            //  2. é vínculo cedido e o órgão selecionado não é o órgão em exercício
            podeExecutarAcoes = false;
        } else {
            // Se o usuário logado tiver perfil de FERIAS_OPERACIONAL => Pode detalhar, mas só pode executar as ações para outros agentes públicos do seu órgão (ou seja, não pode executar ações para suas próprias férias)
            if (this.possuiPerfil(EnumPerfil.FERIAS_OPERACIONAL, dadosUsuarioLogado)) {
                podeExecutarAcoes = dadosUsuarioLogado.sub !== this.vinculoSelecionado.cpf.replace(/[^0-9]/g, '');
            }
        }

        return podeExecutarAcoes;
    }

    ajustarPosicaoMenuAcoes(menu: Pick<Menu, 'container' | 'target'>): void {
        const container = menu.container;
        const alvo = menu.target;

        if (!container || !(alvo instanceof HTMLElement)) {
            throw new Error('Não foi possível posicionar o menu de ações.');
        }

        const retanguloAlvo = alvo.getBoundingClientRect();
        const leftAlvo = retanguloAlvo.left;
        const larguraMenu = container.offsetWidth;
        const larguraViewport = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        const scrollLeft = (window.pageXOffset || document.documentElement.scrollLeft) - (document.documentElement.clientLeft || 0);
        const leftMenuCalculado = leftAlvo + larguraMenu > larguraViewport ? Math.max(0, leftAlvo + scrollLeft + alvo.offsetWidth - larguraMenu) : leftAlvo + scrollLeft;
        const leftMenuDesejado = Math.max(0, leftAlvo + scrollLeft - larguraMenu);
        const folgaLateral = 2;

        container.style.marginLeft = `${leftMenuDesejado - leftMenuCalculado - folgaLateral}px`;

        const topAlvo = retanguloAlvo.top;
        const alturaMenu = container.offsetHeight;
        const alturaAlvo = alvo.offsetHeight;
        const alturaViewport = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        const scrollTop = (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0);
        const abreParaCima = topAlvo + alturaAlvo + alturaMenu > alturaViewport;
        const topMenuCalculado = abreParaCima ? Math.max(scrollTop, topAlvo + scrollTop - alturaMenu) : topAlvo + alturaAlvo + scrollTop;
        const topMenuDesejado = abreParaCima ? Math.max(scrollTop, topAlvo + scrollTop + alturaAlvo - alturaMenu) : topAlvo + scrollTop;
        const folgaVertical = abreParaCima ? 17 : -8;

        container.style.marginTop = `${topMenuDesejado - topMenuCalculado + folgaVertical}px`;
    }

    adicionarAcaoDetalhar(dadosUsuarioLogado: SigepeUserData, exercicio: any) {
        if (this.possuiTransacao(EnumTransacao.FERIAS_DETALHAR, dadosUsuarioLogado)) {
            exercicio.acoesPossiveis.push({
                label: 'Detalhar',
                command: () => {
                    this.detalhar(exercicio);
                }
            });
        }
    }

    adicionarAcaoProgramar(dadosUsuarioLogado: SigepeUserData, exercicio: any) {
        if (this.possuiTransacao(EnumTransacao.FERIAS_PROGRAMAR, dadosUsuarioLogado) && this.gestorPodeExecutarAcoes(dadosUsuarioLogado) && !this.exercicioPossuiFeriasEspeciaisComParcelas(exercicio)) {
            exercicio.acoesPossiveis.push({
                label: 'Programar',
                command: () => {
                    const exercicioAnterior = this.exerciciosFerias.find(e => e.ano === (parseInt(exercicio.ano) - 1).toString());
                    if (exercicioAnterior && (exercicioAnterior.situacao === SituacaoExercicioFeriasEnum.NAO_SOLICITADA.descricao || exercicioAnterior.situacao === SituacaoExercicioFeriasEnum.SOLICITADA.descricao)) {
                        this.getAlertaMsgService().error(
                            formatarMensagem(Message.AVISO_FERIAS_ANTERIORES_PENDENTES_HOMOLOGACAO, {
                                ano: exercicioAnterior.ano
                            })
                        );
                    } else {
                        exercicio.parcelasEmLinha = [];
                        exercicio.parcelas = [];
                        this.programar(exercicio);
                    }
                }
            });
        }
    }

    adicionarAcaoHomologar(dadosUsuarioLogado: SigepeUserData, exercicio: any) {
        if (this.possuiTransacao(EnumTransacao.FERIAS_HOMOLOGAR, dadosUsuarioLogado) && this.gestorPodeExecutarAcoes(dadosUsuarioLogado) && !this.exercicioPossuiFeriasEspeciaisComParcelas(exercicio)) {
            exercicio.acoesPossiveis.push({
                label: 'Homologar',
                command: () => {
                    this.homologar(exercicio);
                }
            });
        }
    }

    adicionarAcaoReprogramar(dadosUsuarioLogado: SigepeUserData, exercicio: any) {
        const modalidadeFeriasEspecial = TipoFeriasEspecialEnum.fromCodigoOuNome(exercicio.tipoFeriasEspecial);
        const modalidadePermiteReprogramacao = modalidadeFeriasEspecial?.id !== TipoFeriasEspecialEnum.JUDICIAL_COM_PARCELAS.id && modalidadeFeriasEspecial?.id !== TipoFeriasEspecialEnum.ADMINISTRATIVO_COM_PARCELAS.id;
        if (modalidadePermiteReprogramacao && this.possuiTransacao(EnumTransacao.FERIAS_REPROGRAMAR, dadosUsuarioLogado) && this.gestorPodeExecutarAcoes(dadosUsuarioLogado) && !this.exercicioPossuiFeriasEspeciaisComParcelas(exercicio)) {
            if (exercicio.parcelasEmLinha && exercicio.parcelasEmLinha.some(parcela => parcela.situacao === SituacaoParcelaFeriasEnum.HOMOLOGADA.descricao)) {
                exercicio.acoesPossiveis.push({
                    label: 'Reprogramar',
                    command: () => {
                        this.reprogramar(exercicio);
                    }
                });
            }
        }
    }

    adicionarAcaoInterromper(dadosUsuarioLogado: SigepeUserData, exercicio: any) {
        if (this.possuiTransacao(EnumTransacao.FERIAS_INTERROMPER, dadosUsuarioLogado) && this.gestorPodeExecutarAcoes(dadosUsuarioLogado) && !this.exercicioPossuiFeriasEspeciaisComParcelas(exercicio) && !exercicio.raioX) {
            if (!this.regimeCeletistaOuAnistiado && this.exercicioEstaNoPrazoParaInterrupcao(exercicio.ano) && exercicio.parcelasEmLinha && exercicio.parcelasEmLinha.some(parcela => parcela.situacao === SituacaoParcelaFeriasEnum.EM_GOZO.descricao || parcela.situacao === SituacaoParcelaFeriasEnum.USUFRUIDA.descricao)) {
                if (this.possuiParcelaPassivelInterrupcao(exercicio)) {
                    exercicio.acoesPossiveis.push({
                        label: 'Interromper',
                        command: () => {
                            this.interromper(exercicio);
                        }
                    });
                }
            }
        }
    }

    adicionarAcaoCancelarInterrupcao(dadosUsuarioLogado: SigepeUserData, exercicio: any) {
        if (this.possuiTransacao(EnumTransacao.FERIAS_CANCELAR_INTERRUPCAO, dadosUsuarioLogado) && this.gestorPodeExecutarAcoes(dadosUsuarioLogado) && !this.exercicioPossuiFeriasEspeciaisComParcelas(exercicio) && !exercicio.raioX) {
            if (!this.regimeCeletistaOuAnistiado && exercicio.parcelasEmLinha && exercicio.parcelasEmLinha.some(parcela => parcela.situacao === SituacaoParcelaFeriasEnum.INTERROMPIDA.descricao)) {
                exercicio.acoesPossiveis.push({
                    label: 'Cancelar Interrupção',
                    command: () => {
                        this.cancelarInterrupcao(exercicio);
                    }
                });
            }
        }
    }

    adicionarAcaoFeriasEspeciaisAdministrativas(dadosUsuarioLogado: SigepeUserData, exercicio: any): void {
        if (this.permiteAcaoFeriasEspeciais(dadosUsuarioLogado, exercicio, EnumTransacao.FERIAS_ESPECIAIS_ADMINISTRATIVA, false)) {
            exercicio.acoesPossiveis.push({
                label: 'Férias Especiais Administrativas',
                command: () => {
                    this.feriasEspeciaisAdministrativas(exercicio);
                }
            });
        }
    }

    adicionarAcaoFeriasEspeciaisJudiciais(dadosUsuarioLogado: SigepeUserData, exercicio: any): void {
        if (this.permiteAcaoFeriasEspeciais(dadosUsuarioLogado, exercicio, EnumTransacao.FERIAS_ESPECIAIS_JUDICIAL, false)) {
            exercicio.acoesPossiveis.push({
                label: 'Férias Especiais Judiciais',
                command: () => {
                    this.feriasEspeciaisJudiciais(exercicio);
                }
            });
        }
    }

    adicionarAcaoFeriasEspeciaisAdministrativasComParcelas(dadosUsuarioLogado: SigepeUserData, exercicio: any): void {
        if (this.permiteAcaoFeriasEspeciais(dadosUsuarioLogado, exercicio, EnumTransacao.FERIAS_ESPECIAIS_ADMINISTRATIVA, true)) {
            exercicio.acoesPossiveis.push({
                label: 'Férias Especiais Administrativas',
                command: () => {
                    this.feriasEspeciaisAdministrativasComParcelas(exercicio);
                }
            });
        }
    }

    adicionarAcaoFeriasEspeciaisJudiciaisComParcelas(dadosUsuarioLogado: SigepeUserData, exercicio: any): void {
        if (this.permiteAcaoFeriasEspeciais(dadosUsuarioLogado, exercicio, EnumTransacao.FERIAS_ESPECIAIS_JUDICIAL, true)) {
            exercicio.acoesPossiveis.push({
                label: 'Férias Especiais Judiciais',
                command: () => {
                    this.feriasEspeciaisJudiciaisComParcelas(exercicio);
                }
            });
        }
    }

    feriasEspeciaisAdministrativas(exercicioFerias: Exercicios): void {
        this.acaoCarregada = true;
        this.router.navigate(['/secure/gerenciar-ferias/consultar-exercicios/ferias-especiais-administrativas'], this.obterDadosExercicioSelecionado(exercicioFerias));
    }

    feriasEspeciaisJudiciais(exercicioFerias: Exercicios): void {
        this.acaoCarregada = true;
        this.router.navigate(['/secure/gerenciar-ferias/consultar-exercicios/ferias-especiais-judiciais'], this.obterDadosExercicioSelecionado(exercicioFerias));
    }

    feriasEspeciaisAdministrativasComParcelas(exercicioFerias: Exercicios): void {
        this.acaoCarregada = true;
        this.router.navigate(['/secure/gerenciar-ferias/consultar-exercicios/ferias-especiais-administrativas-com-parcelas'], this.obterDadosExercicioSelecionado(exercicioFerias));
    }

    feriasEspeciaisJudiciaisComParcelas(exercicioFerias: Exercicios): void {
        this.acaoCarregada = true;
        this.router.navigate(['/secure/gerenciar-ferias/consultar-exercicios/ferias-especiais-judiciais-com-parcelas'], this.obterDadosExercicioSelecionado(exercicioFerias));
    }

    /**
     * Indicador acessível da modalidade especial já persistida no exercício. A sigla e a
     * descrição são textuais, para que a modalidade não dependa de cor ou ícone.
     */
    obterIndicadorFeriasEspeciais(exercicio: any): {
        sigla: string;
        descricao: string;
        textoAlternativo: string;
    } | null {
        const modalidade = TipoFeriasEspecialEnum.fromCodigoOuNome(exercicio?.tipoFeriasEspecial);
        if (!modalidade) {
            return null;
        }

        const descricao = exercicio.descricaoTipoFeriasEspecial || modalidade.descricao;
        return {
            sigla: modalidade.id,
            descricao,
            textoAlternativo: `Férias Especiais ${descricao}`
        };
    }

    /**
     * Legenda dos indicadores presentes no resultado, sem repetir modalidades.
     */
    get legendaFeriasEspeciais(): {
        sigla: string;
        descricao: string;
        textoAlternativo: string;
    }[] {
        const legenda = [];
        (this.exerciciosFerias || []).forEach(exercicio => {
            const indicador = exercicio?.indicadorFeriasEspeciais;
            if (indicador && !legenda.some(item => item.sigla === indicador.sigla)) {
                legenda.push(indicador);
            }
        });
        return legenda;
    }

    /**
     * A disponibilidade da ação segue as capacidades calculadas pelo backend quando a consulta
     * as informa em `acoesFeriasEspeciais`. Sem esse campo, a consulta espelha a mesma matriz de
     * entrada do backend apenas como apoio de experiência: a autorização e a elegibilidade finais
     * continuam sendo decididas na operação.
     */
    private permiteAcaoFeriasEspeciais(dadosUsuarioLogado: SigepeUserData, exercicio: any, transacao: EnumTransacao, comParcelas: boolean): boolean {
        if (!this.gestorPodeExecutarAcoes(dadosUsuarioLogado)) {
            return false;
        }

        const acoesBackend = exercicio?.acoesFeriasEspeciais;
        if (Array.isArray(acoesBackend)) {
            return acoesBackend.some(acao => String(acao).toLowerCase() === transacao.descricao.toLowerCase());
        }

        return this.possuiTransacao(transacao, dadosUsuarioLogado) && (comParcelas ? this.ehExercicioElegivelParaModalidadeComParcelas(exercicio) : this.ehExercicioElegivelParaFeriasEspeciais(exercicio));
    }

    private ehExercicioElegivelParaFeriasEspeciais(exercicio: any): boolean {
        return exercicio?.situacao === SituacaoExercicioFeriasEnum.NAO_SOLICITADA.descricao && (!exercicio.parcelas || exercicio.parcelas.length === 0) && (!exercicio.parcelasEmLinha || exercicio.parcelasEmLinha.length === 0);
    }

    private ehExercicioElegivelParaModalidadeComParcelas(exercicio: any): boolean {
        const situacao = exercicio?.situacao;
        const situacaoElegivel = situacao === SituacaoExercicioFeriasEnum.HOMOLOGADA.descricao || situacao === SituacaoExercicioFeriasEnum.CONCLUIDA.descricao;

        return situacaoElegivel && this.possuiParcelaNaoCancelada(exercicio);
    }

    private possuiParcelaNaoCancelada(exercicio: any): boolean {
        const parcelas = exercicio?.parcelasEmLinha && exercicio.parcelasEmLinha.length > 0 ? exercicio.parcelasEmLinha : exercicio?.parcelas;

        if (!Array.isArray(parcelas)) {
            return false;
        }

        return parcelas.some(parcela => parcela && parcela.ativo !== false && parcela.ordem !== 99 && parcela.situacao !== SituacaoParcelaFeriasEnum.CANCELADA.descricao);
    }

    possuiParcelaPassivelInterrupcao(exercicio: any): boolean {
        if (!exercicio || !exercicio.parcelasEmLinha) {
            return false;
        }

        return exercicio.parcelasEmLinha.some(parcela => (parcela.situacao === SituacaoParcelaFeriasEnum.EM_GOZO.descricao || parcela.situacao === SituacaoParcelaFeriasEnum.USUFRUIDA.descricao) && parcela.quantidadeDias > 1);
    }

    exercicioPossuiFeriasEspeciaisComParcelas(exercicio: any): boolean {
        if (!exercicio) {
            return false;
        }

        var tipo = TipoFeriasEspecialEnum.fromCodigoOuNome(exercicio.tipoFeriasEspecial);

        return TipoFeriasEspecialEnum.ADMINISTRATIVO_COM_PARCELAS === tipo || TipoFeriasEspecialEnum.JUDICIAL_COM_PARCELAS === tipo || TipoFeriasEspecialEnum.JUDICIAL_COM_PARCELAS_POS_MIGRACAO === tipo;
    }
}
